// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .condition-group[data-v-4661bd78] {\n  padding: 1rem;\n  border: 0.5px dashed rgb(var(--vs-primary));\n}\n[dir] .condition-row[data-v-4661bd78] {\n  padding: 0.3rem;\n  border: 0.1px dashed rgb(var(--vs-primary));\n}\n[dir] .condition-list[data-v-4661bd78] {\n  padding: 1rem;\n}\n", ""]);
// Exports
module.exports = exports;
